const callStatusesBirthDays = [
  {id: 'true', name: 'Called'},
  {id: 'false', name: 'Not called'},
]

export default callStatusesBirthDays



// WEBPACK FOOTER //
// ./src/constants/callStatusesBirthDays.js